export const isStringDigitsOnly = (value: string) => /^\d+$/.test(value);
